var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchSales
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('div', {
    staticStyle: {
      "margin-right": "auto"
    }
  }, [_c('RadioGroup', {
    staticClass: "view-switch",
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": _vm.changeView
    },
    model: {
      value: _vm.view,
      callback: function ($$v) {
        _vm.view = $$v;
      },
      expression: "view"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "list"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-menu"
    }
  })], 1), _c('Radio', {
    attrs: {
      "label": "card"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-grid"
    }
  })], 1)], 1)], 1), _c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadSales
    }
  }), _vm.currentUser.superAdmin || _vm.arrayIntersection(['salesAssist'], _vm.currentUser.simpleRole).length > 0 ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateSalesDrawer();
      }
    }
  }, [_vm._v("新增销售项目")]) : _vm._e()], 1), _vm.view === 'list' ? _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (_ref) {
        var row = _ref.row;
        return _vm.currentUser.superAdmin || _vm.arrayIntersection(['factoryLeader', 'technologyLead', 'technology', 'allFactoryLeader'], _vm.currentUser.simpleRole).length > 0 ? [_c('Button', {
          attrs: {
            "type": "info",
            "ghost": "",
            "size": "small",
            "icon": "ios-funnel"
          },
          on: {
            "click": function ($event) {
              return _vm.$refs.RecipeDrawer.openDrawer(row);
            }
          }
        }, [_vm._v("配方")])] : undefined;
      }
    }], null, true)
  })], 1) : _vm._e(), _vm.view === 'card' ? _c('div', {
    staticClass: "card-wrapper"
  }, [_c('div', {
    staticClass: "card-content"
  }, _vm._l(_vm.tableData, function (item) {
    return _c('div', {
      key: item._id,
      staticClass: "card-item"
    }, [_c('Card', {
      staticStyle: {
        "width": "300px"
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.abbr))]), item.prodRecipe ? _c('div', [_c('h3', [_vm._v("#" + _vm._s(item.prodRecipe.NoId) + " " + _vm._s(item.prodRecipe.name))]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("创建人")]), _c('div', [_vm._v(_vm._s(item.prodRecipe.createdBy.name))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("审核人")])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("审核情况")]), _c('div', [_vm._v(_vm._s(item.prodRecipe.status))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("审核时间")]), _c('div', [_vm._v(_vm._s(item.prodRecipe ? item.prodRecipe.verifiedAt : ""))])]), _c('Table', {
      attrs: {
        "columns": _vm.cardColumns,
        "data": item.prodRecipe.detail,
        "border": ""
      }
    })], 1) : _c('div', [_vm._v("暂无生产配方")])])], 1);
  }), 0)]) : _vm._e(), _c('CreateSalesDrawer', {
    ref: "CreateSalesDrawer"
  }), _c('RecipeDrawer', {
    ref: "RecipeDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }